import SectionSkeleton from "../../../../components/ui/SectionSkeleton"
import { Box, Button, Container, Typography } from "@mui/material"
import Images from "../../../../assets/js/Images"
import { Fragment, lazy, Suspense } from "react"
import { Link as NavLink } from "react-router-dom"
import { checkToken, checkUserType } from "../../../../utils/helper"

const TopBannerB = lazy(() => import("../../../../components/common/TopBannerB"))
const CtaSection = lazy(() => import("../../../../components/ui/CtaSection"))
const Video = lazy(() => import("./Video"))
const Text = lazy(() => import("./Text"))

function Testimonials() {
  const authChecked = checkToken();
  const userType = checkUserType();
  const startNowPath = authChecked?.valid
    ? (userType === "specialist" ? "/specialist/profile" : "/member/profile")
    : "/register";

  return (
    <Fragment>
      <Suspense fallback={<SectionSkeleton />}>
        <TopBannerB
          bannerImg={Images?.testimonials}
          headline="Stories of Transformation"
          subHeadline="Real people, real impact."
        />
      </Suspense>

      <Box
        component="section"
        sx={{ py: { xs: 5, lg: 10 } }}
      >
        <Container maxWidth={false} fixed>
          <Typography
            component="h6"
            sx={{
              mb: 2,
              color: "#7a8a9e",
              fontSize: "14px",
              fontWeight: "700",
              textAlign: "center",
              letterSpacing: "3px",
              textTransform: "uppercase",
            }}
          >Testimonials
          </Typography>
          <Suspense fallback={<SectionSkeleton />}>
            <Video />
          </Suspense>
          <Suspense fallback={<SectionSkeleton />}>
            <Text />
          </Suspense>
        </Container>
      </Box>

      <Suspense fallback={<SectionSkeleton />}>
        <CtaSection>
          <Typography
            variant="ctaNormal"
          >Start Your Journey with Us
          </Typography>
          <Button
            variant="CtaButton"
            component={NavLink}
            to={startNowPath}
          >Start Now
          </Button>
        </CtaSection>
      </Suspense>
    </Fragment>
  )
}

export default Testimonials